<template>
  <div class="claim-home" v-if="!claimedHomes || claimedHomes?.length < 1">
    <div class="sub">Understand your home’s value, uncover hidden savings, and build wealth.</div>
    <a class="btn primary small" :href="glb.appUrl + 'homeowner/'">Add a Home</a>
  </div>
  <div class="claimed-homes" v-else>
    <template v-for="(item, i) in claimedHomes">
      <a :key="i" :href="glb.appUrl + 'my-movoto/owned-homes/' + item.propertyId" v-if="i<2">
        <img loading="lazy" v-if="item.photoCount > 0" :alt="item.geo.address"  class="img" :src="item.tnImgPath" />
        <slot v-else name="mapstatic" v-bind="item.geo"></slot>
        {{item.geo.address}}
      </a>
    </template>
    <span v-if="claimedHomes.length > 2">+ {{ claimedHomes.length - 2 }} more</span>
  </div>

</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: 'mvtMenuClaimedHomes',
  emits: ['toggleMenu'],
  props: ['claimedHomes'],
  computed:{
    ...mapGetters('glb', ['glb']),
  },
};
</script>